<template>
  <div class="detail">
    <div class="detail-head clear-fix">
      <div class="fl disFlex">
        <div class="w100">
          <img :src="data.authorAvatar" width="60" height="60" alt="">
        </div>
        <div class="flex1">
          <p class="font18">{{data.nickName}}</p>
          <p class="mt10">{{data.userId}}</p>
        </div>
      </div>

      <div class="fr">
        <ul class="detail-head-content">
          <li>
            <p class="font22">{{data.browseNum}}</p>
            <p>浏览量</p>
          </li>
          <li>
            <p class="font22">{{data.likeNum}}</p>
            <p>点赞数</p>
          </li>
          <li>
            <p class="font22">{{data.collectionNum}}</p>
            <p>收藏数</p>
          </li>
          <li>
            <p class="font22">{{data.commentsNum}}</p>
            <p>评论数</p>
          </li>
          <li>
            <p class="font22">{{data.forwardNum}}</p>
            <p>转发数</p>
          </li>
        </ul>
      </div>
    </div>

    <el-form label-width="120px">
      <el-form-item label="资讯标题：">
        {{data.title}}
      </el-form-item>
      <el-form-item label="正文：">
        <div class="box-height-300">
          {{data.content}}
        </div>
      </el-form-item>
      <el-form-item label="封面：">
        <show-img class="mr10" :value="data.cover" :key="index"/>
      </el-form-item>
      <el-form-item label="所属分类：">
        {{data.type}}
      </el-form-item>
      <el-form-item label="标签：">
        <el-tag class="mr10" size="medium" v-for="(item, index) in data.labels" :key="index">{{item.labelName}}</el-tag>
      </el-form-item>
      <el-form-item label="发布人：">
        {{data.authorName}}
      </el-form-item>
      <el-form-item label="总结：">
        {{data.summary}}
      </el-form-item>
      <el-form-item label="创建时间：">
        {{data.createdAt}}
      </el-form-item>
      <el-form-item label="状态：">
        {{data.statusName}}
      </el-form-item>
      <el-form-item label="置顶位置：">
        {{data.stickType}}
      </el-form-item>
      <el-form-item label="置顶时间：">
        {{data.stickDays}}
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import ShowImg from '@/components/ShowImg'

  export default {
    components: {ShowImg},
    props: ['data'],
  }
</script>

<style scoped>
  .detail {
    padding-bottom: 50px;
  }

  .detail-head {
    background-color: #ebeef5;
    padding: 20px 30px 20px 70px;
  }

  .detail-head-content > li {
    display: inline-block;
    text-align: center;
    margin-right: 40px;
    line-height: 30px;
  }

  .detail-content {
    padding: 0 50px;
  }

  .detail-content-title {
    font-size: 20px;
    font-weight: bold;
    padding-top: 30px;
    padding-bottom: 15px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
  }

  .production {
    border-bottom: 1px solid #ebeef5;
    padding: 5px;
  }

  .production-title {
    position: relative;
    display: inline-block;
    color: #000;
  }

  .production-title > span {
    position: absolute;
    right: -70px;
    top: 0;
    padding: 1px 10px;
    border: 1px solid #8b8d92;
    border-radius: 10px;
    font-size: 12px;
  }

  .production-time {
    color: rgb(148, 148, 148);
    font-size: 12px;
    line-height: 30px;
  }

  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }
</style>
